import script from "./ProductList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductList.vue?vue&type=script&setup=true&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=9cae4fea&lang=scss"

const __exports__ = script;

export default __exports__